import { FormInstance } from 'antd';
import { PLAYLIST_CONTENT_API_PATH } from 'constants/api';
import { seasonService, seriesService } from 'content/service';
import { SeriesInterface } from 'content/type/seriesType';
import { ApiService } from 'service/api/apiService';
import { FetchResult } from 'type/apiType';
import { SeasonInterface } from 'type/seasonType';
import { PlaylistRuleInterface, UpdateRuleInterface } from '../types/playlistRuleType';

class PlaylistRuleService {
  constructor(private apiService: ApiService<PlaylistRuleInterface>) {}

  public async fetchRules(playlistId: number): Promise<PlaylistRuleInterface[]> {
    return await this.apiService.fetchChildItemsByParentId<PlaylistRuleInterface[]>(
      playlistId,
      'rules'
    );
  }

  public async fetchSeriesRules(
    form: FormInstance,
    playlistId: number,
    query?: URLSearchParams
  ): Promise<FetchResult<SeriesInterface>> {
    const targetSeriesIds = [];
    const seriesFormData = form.getFieldValue('series');
    if (!seriesFormData) {
      const fetchedRules = await this.apiService.fetchChildItemsByParentId<PlaylistRuleInterface[]>(
        playlistId,
        'rules'
      );
      const selectedSeries = fetchedRules.filter(rule => rule.value_type === 'series');
      const selectedSeriesIds =
        selectedSeries.length > 0
          ? selectedSeries[0].value.split(',').map((value: string) => Number(value))
          : [];
      targetSeriesIds.push(...selectedSeriesIds);
    } else {
      targetSeriesIds.push(...seriesFormData);
    }
    return await seriesService.fetchByIds(
      targetSeriesIds,
      Object.fromEntries(query?.entries() ?? [])
    );
  }

  public async fetchSeasonRules(
    form: FormInstance,
    playlistId: number,
    query?: URLSearchParams
  ): Promise<FetchResult<SeasonInterface>> {
    const targetSeasonIds = [];
    const seasonFormData = form.getFieldValue('season');
    if (!seasonFormData) {
      const fetchedRules = await this.apiService.fetchChildItemsByParentId<PlaylistRuleInterface[]>(
        playlistId,
        'rules'
      );
      const selectedSeasons = fetchedRules.filter(rule => rule.value_type === 'season');
      const selectedSeasonIds =
        selectedSeasons.length > 0
          ? selectedSeasons[0].value.split(',').map((value: string) => Number(value))
          : [];
      targetSeasonIds.push(...selectedSeasonIds);
    } else {
      targetSeasonIds.push(...seasonFormData);
    }
    return await seasonService.fetchByIds(
      targetSeasonIds,
      Object.fromEntries(query?.entries() ?? [])
    );
  }

  public async upsertPlaylistRule(playlistId: number, rules: UpdateRuleInterface[]): Promise<void> {
    await this.apiService.updateItemsForParent(playlistId, 'upsert-rule', rules);
  }
}

export const playlistRuleService = new PlaylistRuleService(
  new ApiService<PlaylistRuleInterface>(PLAYLIST_CONTENT_API_PATH)
);
